const NewInputField = class NewInputField {
    constructor(config) {
        this.addNewInputField = config.addNewInputField;
        this.addNewTextarea = config.addNewTextarea;
    }

    init() {
        let $self,
            dataName;

        this.addNewInputField.on("click", function () {
            $self = $(this);
            dataName = $self.data('input-name');
            let newInput = `                       
                    <input type="text" class="top-space" name="${dataName}" value="">
              `;

            $(newInput).insertBefore($self);
        });

        this.addNewTextarea.on("click", function () {
            $self = $(this);
            dataName = $self.data('textarea-name');
            let newTextarea = `                       
                    <textarea type="text" class="top-space" name="${dataName}"></textarea>
              `;

            $(newTextarea).insertBefore($self);
        });
    }
};

export {NewInputField};


// WEBPACK FOOTER //
// ./static/js/components/NewInputField.js